import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ImageComponentComponent} from "./image-component.component";
import {CustomGalleryImageComponent} from "../custom-gallery-image/custom-gallery-image.component";

@Component({
  selector: "phoenix-gallery-image",
  templateUrl: "./image-component.component.html",
  styleUrls: ["./image-component.component.scss"],
  standalone: false,
})
export class PhoenixImageComponentComponent extends ImageComponentComponent implements AfterViewInit {
    @ViewChild(CustomGalleryImageComponent) customGalleryImage!: CustomGalleryImageComponent;

    constructor(public el: ElementRef,
                public cdr: ChangeDetectorRef,
    ) {
        super();
    }

    ngAfterViewInit() {
        this.cdr.detectChanges();
    }
}
